import {
    GET_CONDITION,
    SET_CONDITION
} from "./ConditionType"

const getCondition = () => ({
    type: GET_CONDITION
});

const setCondition = (conditionDropDown: any) => ({
    type: SET_CONDITION,
    conditionDropDown: conditionDropDown
});

export {
    getCondition,
    setCondition
}
